import tmsApi from '../../api/tmsApi';
import helper from '../helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    order_status: [],
    query: {
      search: '',
      company_id: null,
      customer_id: null,
      destination_id: null,
      page: {
        lastData: null,
        count: 10,
      },
      sort: {
        by: 'ID',
        direction: 'DESC',
      },
      skip: {
        by: 'ID',
      },
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    REPLACE_DATA(state, orders) {
      state.order_status.splice(0, state.order_status.length, ...orders);
    },
    CLEAR_DATA(state) {
      state.order_status.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.order_status.push(data);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    SET_QUERY_DATE(state, dateRange) {
      const [start_date, end_date] = dateRange;
      state.query.start_date = start_date;
      state.query.end_date = end_date;
    },
    SET_QUERY_LAST_DATA({ query }, data) {
      query.page.lastData = data;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.search = search;
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.customer_id = null;
      query.destination_id = null;
      query.page.lastData = null;
      query.page.count = 10;
      query.sort.by = 'ID';
      query.sort.direction = 'DESC';
    },
  },
  getters: {
    order_status(state) {
      return state.order_status;
    },
  },
  actions: {
    LOAD_DATA({ commit, state, rootState }, payloads = {}) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const { by: skipBy } = state.query.skip;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const customerId = createInputParam(state.query, 'customer_id', false);
      const destinationId = createInputParam(state.query, 'destination_id', false);
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: ${skipBy}
            ${after}
            ${before}
          },
        `;
      }

      const { start_date = null, end_date = null, assigned = null } = payloads;
      const startDateQuery = start_date ? `start_date: "${start_date}"` : '';
      const endDateQuery = end_date ? `end_date: "${end_date}"` : '';
      const assignedStatus = assigned !== null ? `assigned: ${assigned}` : '';

      const query = `
        {
          orders(
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
            ${customerId}
            ${destinationId}
            ${startDateQuery}
            ${endDateQuery}
            ${assignedStatus}
          ) {
            id
            number
            sequence
            metadata
            status
            created_at
            updated_at
            delivery_date
            type
            company {
              id
              name
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            shipment {
              id
              number
              vehicle {
                reg_no
                gps_devices {
                  number
                }
                driver {
                  name
                }
              }
              metadata
            }
            customer {
              id
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            confirmations {
              key
              name
              signature
              created_at
              metadata
              id
            }
            units {
              number
              type
            }
            delivery_status {
              name
              datetime
            }
          }
        }
      `;
      return api(query, 'orders_status').then(({ data }) => {
        const { orders } = data;
        commit('REPLACE_DATA', orders);
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.build(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const { by: skipBy } = state.query.skip;
      const limit = count;
      const companyId = state.query.company_id === null
        ? '' : `company_id: ${state.query.company_id}`;
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: ${skipBy}
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          orders: find_orders(
            query: "${state.query.search}",
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
          ) {
            id
            number
            sequence
            metadata
            created_at
            updated_at
            company {
              id
              name
            }
            destination {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            shipment {
              id
              number
              vehicle {
                reg_no
                gps_devices {
                  number
                }
                driver {
                  name
                }
              }
              metadata
            }
            customer {
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            confirmations {
              key
              name
              signature
              created_at
              metadata
              id
            }
            delivery_status {
              name
              datetime
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      // commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_orders').then(({ data }) => {
        const { orders } = data;
        orders.forEach((order) => {
          commit('ADD_DATA_ON_LIST', order);
        }, this);
      });
      // .then(() => {
      //   setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      // }).catch(() => {
      //   commit('ADD_ERROR', 'FIND_DATA');
      // });
    },
    REMOVE_ORDER_CONFIRMATION({ rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { id } = payloads;

      const mutation = `mutation {
        deleted: delete_confirmation(id: ${id})
      }`;

      return api(mutation, 'delete_confirmation').then(({ data }) => {
        const { deleted } = data;
        return deleted;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/shipment_md/order_status.js